import { useConnect } from '@lore/query-connect';
import { tags_educator } from '@/utils/query-helpers';
import { REQUIRED_EDUCATOR_FIELDS } from '@/utils/user/REQUIRED_FIELDS';

export default function useEducatorsAffiliatedWithNetworkSite(network, timestamp, currentTimestamp) {
  return useConnect('user.find', {
    where: {
      eager: {
        $where: {
          ...tags_educator(),
          networkId: network?.id,
          createdAt: {
            $lte: timestamp.end
          },
          $and: {
            ...REQUIRED_EDUCATOR_FIELDS,
            inactive: false,
            $or: [
              {
                sleepingStartingAt: {
                  $gte: currentTimestamp
                }
              },
              {
                sleepingEndingAt: {
                  $lte: currentTimestamp
                }
              }
            ]
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
